export const APT_COLUMNS = [
  {
    key: "kapt_code",
    label: "K-APT 코드",
    align: "text-left"
  },
  {
    key: "apt_name",
    label: "아파트명",
    align: "text-left",
    editType: "input"
  },
  {
    key: "road_addr",
    label: "도로명주소",
    align: "text-left"
  },
  {
    key: "unit_count",
    label: "세대수",
    editType: "link",
    to: (item) => `/admin/apt/${item.kapt_code}/unit-size`
  },
  {
    key: "move_in_date",
    label: "입주일",
    editType: "input",
    inputType: "date"
  },
  {
    key: "heat_type",
    label: "난방 타입",
    editType: "select",
    options: [
      { value: 0, label: "지역 난방" },
      { value: 1, label: "개별 난방" }
    ]
  },
  {
    key: "region_key",
    label: "요금 관할 지역",
    editType: "input"
  },
  {
    key: "ended_at",
    label: "서비스 종료일",
    editType: "input",
    inputType: "date"
  },
  {
    key: "is_active",
    label: "사용 여부",
    editType: "bool"
  }
]

export const DATE_FIELDS = ["move_in_date", "ended_at"]

export const rowGridClass =
  "grid grid-cols-[minmax(120px,1fr)_1.5fr_2.5fr_1fr_minmax(120px,1fr)_120px_minmax(130px,1fr)_minmax(120px,1fr)_100px]"
